export const ArtworkTypes = {
  BOX: "Box",
  LABEL: "Label",
  LEAFLET: "Leaflet",
  SACHET: "Sachet",
  SHIPPERLABEL: "Shipper Label",
  BLISTER: "Blister",
  SHIPPERCARTON: "Shipper Carton",
  PALLETLABEL: "Pallet Label",
  WRAPLABEL: "Wrap Label",
  WHITEBOXLABEL: "White box Label",
};

export const artworkTypeConfig = [
  {
    key: ArtworkTypes.BOX,
    type: ArtworkTypes.BOX,
    icon: "bi bi-box",
    title: "Artwork version box",
    emptyMessage: "No box artwork version added",
    tooltip: "Artwork version box",
  },
  {
    key: ArtworkTypes.LABEL,
    type: ArtworkTypes.LABEL,
    icon: "bi bi-tag",
    title: "Artwork version label",
    emptyMessage: "No label artwork version added",
    tooltip: "Artwork version label",
  },
  {
    key: ArtworkTypes.LEAFLET,
    type: ArtworkTypes.LEAFLET,
    icon: "bi bi-card-list",
    title: "Artwork version leaflet",
    emptyMessage: "No leaflet artwork version added",
    tooltip: "Artwork version leaflet",
  },
  {
    key: ArtworkTypes.SACHET,
    type: ArtworkTypes.SACHET,
    icon: "bi bi-bag",
    title: "Artwork version sachet",
    emptyMessage: "No sachet artwork version added",
    tooltip: "Artwork version sachet",
  },
  {
    key: ArtworkTypes.SHIPPERLABEL,
    type: ArtworkTypes.SHIPPERLABEL,
    icon: "bi bi-truck",
    title: "Artwork version shipper label",
    emptyMessage: "No shipper label artwork version added",
    tooltip: "Artwork version shipper label",
  },
  {
    key: ArtworkTypes.BLISTER,
    type: ArtworkTypes.BLISTER,
    icon: "bi bi-boxes",
    title: "Artwork version blister",
    emptyMessage: "No blister artwork version added",
    tooltip: "Artwork version blister",
  },
  {
    key: ArtworkTypes.SHIPPERCARTON,
    type: ArtworkTypes.SHIPPERCARTON,
    icon: "bi bi-box2",
    title: "Artwork version shipper carton",
    emptyMessage: "No shipper carton artwork version added",
    tooltip: "Artwork version shipper carton",
  },
  {
    key: ArtworkTypes.PALLETLABEL,
    type: ArtworkTypes.PALLETLABEL,
    icon: "bi bi-layout-text-sidebar",
    title: "Artwork version Pallet Label",
    emptyMessage: "No Pallet Label artwork version added",
    tooltip: "Artwork version Pallet Label",
  },
  {
    key: ArtworkTypes.WRAPLABEL,
    type: ArtworkTypes.WRAPLABEL,
    icon: "bi bi-journal-text",
    title: "Artwork version Wrap Label",
    emptyMessage: "No Wrap Label artwork version added",
    tooltip: "Artwork version Wrap Label",
  },
  {
    key: ArtworkTypes.WHITEBOXLABEL,
    type: ArtworkTypes.WHITEBOXLABEL,
    icon: "bi bi-justify-left",
    title: "Artwork version White Box Label",
    emptyMessage: "No White Box Label artwork version added",
    tooltip: "Artwork version White Box Label",
  },
];
